import "./styles/IconPicker.scss";
import {fontAwesomeService} from "../../api/FontAwesomeService";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";
import Textfield from "@atlaskit/textfield";
import Tooltip from '@atlaskit/tooltip';
import {Popup} from "@atlaskit/popup";
import Button from "@atlaskit/button";
import ChevronUpIcon from "@atlaskit/icon/glyph/chevron-up";
import ChevronDownIcon from "@atlaskit/icon/glyph/chevron-down";
import classNames from "classnames";

interface IconPickerComponentProps {
    iconValue: string
    iconSelected: (icon: string) => void
}

function IconPicker(props: Readonly<IconPickerComponentProps>) {
    const [dialogShown, setDialogShown] = React.useState<boolean>(false);
    const [searchTerm, setSearchTerm] = React.useState<string>("");

    const openDialog = () => {
        setDialogShown(true);
    }

    const closeDialog = () => {
        setDialogShown(false);
        setSearchTerm("");
    }

    const selectIcon = (iconName: string) => {
        props.iconSelected(iconName);
        closeDialog();
    }

    const filteredIconsList = (): string[] => {
        if (searchTerm.trim().length > 0) {
            return fontAwesomeService.searchIcons(searchTerm);
        }
        return fontAwesomeService.presetIcons.map(icon => icon.iconName);
    }

    const chevronBasedOnState = () => {
        return <span className={"chevron"}>{dialogShown ? <ChevronUpIcon label={"close icon picker"}/> : <ChevronDownIcon label={"open icon picker"}/>}</span>;
    };

    const inlineDialogContent = () => {
        return <div className={"dialog-content"}>
            <Textfield name="decisionFilter" placeholder={"Search icons..."} value={searchTerm}
                       onChange={(event) => setSearchTerm(event.currentTarget.value)}/>
            <div className={"icon-grid"}>
                <div className={"icon-wrapper no-icon"} onClick={() => selectIcon("")}>
                    No icon
                </div>
                {filteredIconsList().map(iconName => {
                    return <div key={iconName}
                                onClick={() => {
                                    selectIcon(iconName)
                                }}
                                className={classNames("icon-wrapper", {"selected": iconName === props.iconValue})}>
                        <FontAwesomeIcon icon={fontAwesomeService.icon(iconName)} size="2x" title={iconName}></FontAwesomeIcon>
                    </div>
                })}
            </div>
        </div>
    }

    return <>
        <Tooltip content="Set icon">
            <Popup
                isOpen={dialogShown}
                onClose={closeDialog}
                content={() => inlineDialogContent()}
                placement={`auto-start`}
                trigger={(triggerProps) => (
                    <Button {...triggerProps}
                            className={"icon-picker"}
                            onClick={openDialog}
                            iconAfter={chevronBasedOnState()}
                    >
                        {props.iconValue.trim().length > 0
                            ? <FontAwesomeIcon icon={fontAwesomeService.icon(props.iconValue)} size="lg"/>
                            : <span>-</span>
                        }
                    </Button>
                )}
            />
        </Tooltip>
    </>
}

export default IconPicker;
